import Vue from "vue";
import VueI18n from "vue-i18n";
import VueRouter from "vue-router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/ar";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import BlockUIService from "./Shared/BlockUIService.js";
import Layout from "./components/Layout/Layout.vue";
import DataService from "./Shared/DataService";
import VuePhoneNumberInput from "vue-phone-number-input";

Vue.use(Vuetify);
Vue.use(VueI18n);
Vue.use(VueRouter);
Vue.use(ElementUI, { locale });
Vue.component("vue-phone-number-input", VuePhoneNumberInput);

Vue.config.productionTip = false;

Vue.prototype.$http = DataService;
Vue.prototype.$blockUI = BlockUIService;

export const eventBus = new Vue();

// Lazy loaded routes
const Home = () => import("./components/Home/Home.vue");
const TrainingFoundations = () => import("./components/TrainingFoundations/TrainingFoundations.vue");
const Login = () => import("./components/Login/Login.vue");
const SendEmail = () => import("./components/SendEmail/SendEmail.vue");
const ApprovedTrainer = () => import("./components/ApprovedTrainer/ApprovedTrainer.vue");
const OfficeUsers = () => import("./components/OfficeUsers/OfficeUsers.vue");
const Trainers = () => import("./components/Trainers/Trainers.vue");
const Offices = () => import("./components/Offices/Offices.vue");
const OfficePage = () => import("./components/OfficePage/OfficePage.vue");
const VerifiedTrainingFoundation = () => import("./components/VerifiedTrainingFoundation/VerifiedTrainingFoundation.vue");
const ContactUs = () => import("./components/ContactUs/ContactUs.vue");
const TrainingFoundationProfile = () => import("./components/TrainingFoundationProfile/TrainingFoundationProfile.vue");
const JobSeekers = () => import("./components/JobSeekers/JobSeekers.vue");
const AddJobSeekers = () => import("./components/JobSeekers/AddJobSeekers/AddJobSeekers.vue");

const routes = [
    { path: "/", component: Home, name: "Home" },
    { path: "/ApprovedTrainer", component: ApprovedTrainer, name: "ApprovedTrainer" },
    { path: "/TrainingFoundations", component: TrainingFoundations, name: "TrainingFoundations" },
    { path: "/Login", component: Login, name: "Login" },
    { path: "/Trainers", component: Trainers, name: "Trainers" },
    { path: "/Offices", component: Offices, name: "Offices" },
    { path: "/SendEmail", component: SendEmail, name: "SendEmail" },
    { path: "/VerifiedTrainingFoundation", component: VerifiedTrainingFoundation, name: "VerifiedTrainingFoundation" },
    { path: "/OfficeUsers/:OfficeId", component: OfficeUsers, name: "OfficeUsers" },
    { path: "/OfficePage/:OfficeId", component: OfficePage, name: "OfficePage" },
    { path: "/ContactUs", component: ContactUs, name: "ContactUs" },
    { path: "/TrainingFoundationProfile/:trainingFoundationId", component: TrainingFoundationProfile, name: "TrainingFoundationProfile" },
    { path: "/JobSeekers", component: JobSeekers, name: "JobSeekers" },
    { path: "/AddJobSeekers", component: AddJobSeekers, name: "AddJobSeekers" },
];

const router = new VueRouter({
    mode: "history",
    base: __dirname,
    linkActiveClass: "active",
    routes,
});

Vue.filter("toUpperCase", function (value) {
    if (!value) return "";
    return value.toUpperCase();
});

new Vue({
    router,
    vuetify: new Vuetify({ rtl: true }),
    render: (h) => h(Layout),
}).$mount("#app");
